import React, {useCallback, useEffect, useState} from 'react';
import {BsSquareFill} from "react-icons/bs";
import axios from '../../services/axiosInstance';
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import {MdKeyboardArrowDown} from "react-icons/md";
import maCateImg from "../../assets/img/m-a-cate.png";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import AdminCtItemModify from "./AdminCtItemModify";

function AdminCustomsItemPg() {

    /** region DataTable */

    const [data, setData] = useState([]);

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');

    const [hsCode, sethsCode] = useState("");
    const [hsCodeNm, sethsCodeNm] = useState("");
    const [hsCodeEnNm, sethsCodeEnNm] = useState("");
    const [mcNm, setMcNm] = useState("");
    const [mcAddress, setMcAddress] = useState("");
    const [mcZipcode, setMcZipcode] = useState("");

    const code = (e) => {
        sethsCode(e.target.value);
    };

    const codeNm = (e) => {
        sethsCodeNm(e.target.value);
    };

    const codeEnNm = (e) => {
        sethsCodeEnNm(e.target.value);
    };

    const handleMcName = (e) => {
        setMcNm(e.target.value);
    };

    const handleMcAddress = (e) => {
        setMcAddress(e.target.value);
    };

    const handleMcZipcode = (e) => {
        setMcZipcode(e.target.value);
    };

    const [selectedRowData, setSelectedRowData] = useState(true);

    function handleRowClick(cData) {
        setSelectedRowData(cData);
    }

    //region ScrollPagination

    const [displayLimit, setDisplayLimit] = useState(10);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [data.length, displayLimit]);

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop + 1 >= document.documentElement.scrollHeight) {
            if (data.length > displayLimit && displayLimit < 30) {
                setDisplayLimit(prevLimit => prevLimit + perPg);
            }
        }
    };

    const loadMoreData = () => {
        setDisplayLimit(prevLimit => prevLimit + perPg);
    };

    // endregion

    //region Pagination

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(15);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const handleSelectChange = (e) => {
        const newPerPage = parseInt(e.target.value);
        setperPg(newPerPage);
        // setDisplayLimit(newPerPage);
        setCurrentPage(1);
    };

    useEffect(() => {
        setDisplayLimit(perPg);
    }, [perPg]);

    // endregion

    // region Alert

    const [alertShow, setAlertShow] = useState(false);
    const [alertShow2, setAlertShow2] = useState(false);

    const Alert = (() => {
        setAlertShow(true)
    })
    const Alert2 = (() => {
        setAlertShow2(true)
    })
    const modalCancel = useCallback(() => {
        setAlertShow(false);
    })
    const modalCancel2 = useCallback(() => {
        setAlertShow2(false);
    })

    // endregion

    //region CheckBox

    const [checked, setChecked] = useState([]);

    const checkBoxChange = (dataItem) => {
        setChecked((prevSelectedData) => {
            if (prevSelectedData.some(item => item.seqNum === dataItem.seqNum)) {
                return prevSelectedData.filter((item) => item.seqNum !== dataItem.seqNum);
            } else {
                return [...prevSelectedData, dataItem];
            }
        });
    };

    const allCheckBoxChange = (e) => {
        if (e.target.checked) {
            setChecked(data);
        } else {
            setChecked([]);
        }
    };

    //endregion

    /** endregion */

    /** region Event */

    useEffect(() => {
        select();
    }, [])

    const select = () => {
        axios.get('/admincustomitem/admincustomitemselect')
            .then((response) => {
                setData(response.data)
                setChecked([]);
                sethsCode("");
                sethsCodeNm("");
                sethsCodeEnNm("");
                setMcNm("");
                setMcAddress("");
                setMcZipcode("");
            }, [])
            .catch()
    }

    const [saveFailedShow, setSaveFailedShow] = useState(false);
    const closeSaveFailedShow = () => {
        setSaveFailedShow(false);
    }

    const [nonSelectedShow, setNonSelectedShow] = useState(false);
    const closeNonSelectedShow = () => {
        setNonSelectedShow(false);
    }

    const [nonDataShow, setNonDataShow] = useState(false);
    const closeNonDataShow = () => {
        setNonDataShow(false);
    }

    const validSave = () => {
        let isValue = true;
        if (!hsCode || !hsCodeNm || !hsCodeEnNm) {
            setNonDataShow(true);
            isValue = false
        }
        return isValue;
    }

    const customItemNewSave = () => {
        if (validSave()) {
            axios.post(
                '/admincustomitem/admincustomitemsave',
                {
                    hsCode: hsCode,
                    hsCodeNm: hsCodeNm,
                    hsCodeEnNm: hsCodeEnNm,
                    mcNm: mcNm,
                    mcAddress: mcAddress,
                    mcZipcode: mcZipcode,
                },
                {
                    headers: {
                        Authorization: LCAT,
                        'Content-Type': 'application/json',
                    },
                }
            )
                .then(() => {
                    select();
                    setAlertShow(false);
                })
                .catch((error) => {
                    console.log("HSCODE 중복 또는 서버 오류 발생 : ", error);
                    setSaveFailedShow(true);
                });
        }
    };

    const [deleteShow, setDeleteShow] = useState(false);
    const deleteMsg1 = "선택하신 데이터를 삭제하시겠습니까?";
    const deleteMsg2 = "삭제 후 복구가 불가능합니다"
    const closeDeleteShow = () => {
        setDeleteShow(false);
    }
    const openDeleteShow = () => {
        if (checked.length === 0) {
            setNonSelectedShow(true);
        } else {
            setDeleteShow(true);
        }
    }

    const [deleteFailedShow, setDeleteFailedShow] = useState(false);
    const closeDeleteFailedShow = () => {
        setDeleteFailedShow(false);
    }
    const deleteCustomItem = () => {
        axios.post(
            '/admincustomitem/deleteCustomItem', checked,
            {
                headers: {
                    Authorization: LCAT,
                    'Content-Type': 'application/json',
                },
            }
        )
            .then(() => {
                select();
                setDeleteShow(false);
            })
            .catch((error) => {
                console.log("HSCODE 중복 또는 서버 오류 발생 : ", error);
                setDeleteFailedShow(true);
            });
    }


    const [modifyPopupShow, setModifyPopupShow] = useState(false);
    const closeModifyPopupShow = () => {
        setModifyPopupShow(false);
    }
    const openModifyShow = () => {
        if (checked.length === 0) {
            setNonSelectedShow(true);
        } else {
            setModifyPopupShow(true);
        }
    }

    const [modifyFailedShow, setModifyFailedShow] = useState(false);
    const closeModifyFailedShow = () => {
        setModifyFailedShow(false);
    }

    const modifyCustomItem = (updatedList) => {
        axios.post(
            '/admincustomitem/modifyCustomItem', updatedList,
            {
                headers: {
                    Authorization: LCAT,
                    'Content-Type': 'application/json',
                },
            }
        ).then(() => {
            select();
            setAlertShow(false);
            closeModifyPopupShow();
        })
            .catch((error) => {
                console.log("HSCODE 중복 또는 서버 오류 발생 : ", error);
                setModifyFailedShow(true);
            });
    };

    // region Excel

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;

    const excelDown = () => {
        try {
            const selectedRows = data.filter((item) => checked.includes(item.seqNum));

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            workbook.addWorksheet('Data');

            const sheetOne = workbook.getWorksheet('Data');

            sheetOne.getRow(1).font = {
                name: '맑은 고딕',
                bold: true,
                size: 11
            };
            sheetOne.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            };
            sheetOne.getRow(1).height = 30;
            sheetOne.columns = [
                {
                    header: '번호',
                    key: 'seqNum',
                    hidden: false,
                    height: 15,
                    width: 7,
                    style: {alignment: {horizontal: 'center'}}
                },
                {header: '품목명', key: 'hsCodeNm', width: 25, style: {alignment: {horizontal: 'center'}}},
                {header: 'HSCODE', key: 'hsCode', width: 12, style: {alignment: {horizontal: 'center'}}},
                {header: '등록자', key: 'regNm', width: 12, style: {alignment: {horizontal: 'center'}}},
                {header: '등록일시', key: 'regTime', width: 20, style: {alignment: {horizontal: 'center'}}},
            ];
            selectedRows.map((item, index) => {
                sheetOne.addRow(item);
                for (let loop = 1; loop <= 9; loop++) {
                    const col = sheetOne.getRow(index + 2).getCell(loop);
                    col.font = {name: '맑은 고딕', size: 10};
                }
            });

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `통관품목정보_` + DateViewValue + `.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            })
        } catch (error) {
            console.error(error);
        }
    }

    // endregion

    /** endregion */

    return (
        <div className="AdminCustomsItemPg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">통관품목설정</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card m-b-40 font-t-cont">
                    <div className="admin-event-wrap">
                        <div className="admin-btn-wrap-l">
                            <BsSquareFill className="admin-tb-header-notice"/>
                            <a>내용품명 등록</a>
                        </div>
                        <div className="admin-btn-wrap-r">
                            <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event"
                                    onClick={customItemNewSave} style={{float: "right", marginBottom: "15px"}}>저장
                            </button>
                        </div>
                    </div>
                    <table className="admin-ver-tb">
                        <tbody className="ver-tb-body">
                        {selectedRowData && (
                            <tr>
                                <th><p>품목명</p></th>
                                <td className="font-b text-center">
                                    <input value={hsCodeNm} onChange={codeNm}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"품목명을 입력해주세요"} minLength="1" maxLength={30} type={"text"}/>
                                </td>
                                <th><p>품목명(English)</p></th>
                                <td className="font-b text-center">
                                    <input value={hsCodeEnNm} onChange={codeEnNm}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"품목명(영문)을 입력해주세요"} minLength="1" maxLength={300} type={"text"}/>
                                </td>
                                <th><p>HS CODE</p></th>
                                <td className="font-b text-center">
                                    <input value={hsCode} onChange={code}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"중복 HS CODE 등록불가"} minLength="1" maxLength={13} type={"text"}/>
                                </td>
                            </tr>
                        )}
                        </tbody>
                        <tbody className="ver-tb-body">
                        {selectedRowData && (
                            <tr>
                                <th><p>제조사상호</p></th>
                                <td className="font-b text-center">
                                    <input value={mcNm} onChange={handleMcName}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"제조사상호를 입력해주세요"} minLength="1" maxLength={50} type={"text"}/>
                                </td>
                                <th><p>주소</p></th>
                                <td className="font-b text-center">
                                    <input value={mcAddress} onChange={handleMcAddress}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"주소를 입력해주세요"} minLength="1" maxLength={200} type={"text"}/>
                                </td>
                                <th><p>우편번호</p></th>
                                <td className="font-b text-center">
                                    <input value={mcZipcode} onChange={handleMcZipcode}
                                           className="admin-input-line wd-200 ht-35 p-l-5 m-b-9"
                                           placeholder={"우편번호를 입력해주세요"} minLength="1" maxLength={6} type={"text"}/>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <div className="admin-wrap-card">
                    <div className="admin-event-wrap">
                        <div className="admin-event-wrap-btn">
                            <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                        </div>
                        <div className="admin-event-wrap-btn gap10">
                            <button onClick={excelDown}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">EXCEL
                            </button>
                            <button onClick={openDeleteShow}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">삭제
                            </button>
                            <button onClick={openModifyShow}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">수정
                            </button>
                        </div>
                    </div>
                    <div className="div-tb">
                        <div className="div-tb-head ht-60">
                            <div style={{width: "40px"}}>
                                <input className="admin-input-chkBox m-0-a" type="checkbox"
                                       checked={checked.length === data.length} onChange={allCheckBoxChange}/>
                            </div>
                            <div style={{width: "45px"}}><p>번호</p></div>
                            <div style={{width: "130px"}}><p>품목명</p></div>
                            <div style={{width: "220px"}}><p>품목명(English)</p></div>
                            <div style={{width: "80px"}}><p>HS CODE</p></div>
                            <div style={{width: "120px"}}><p>제조사</p></div>
                            <div style={{width: "110px"}}><p>등록자</p></div>
                            <div style={{width: "100px"}}><p>등록일시</p></div>
                            <div style={{width: "110px"}}><p>수정자</p></div>
                            <div style={{width: "100px"}}><p>수정일시</p></div>
                        </div>
                        {data.slice(0, displayLimit).map((cData, i) => (
                            <div key={cData.seqNum} className="div-tb-body ht-70">
                                <div style={{width: "40px"}}>
                                    <input className="admin-input-chkBox m-0-a" type="checkbox" name={cData.seqNum}
                                           checked={checked.some(item => item.seqNum === cData.seqNum)}
                                           onChange={() => checkBoxChange(cData)}/>
                                </div>
                                <div className="text-center" style={{width: "45px"}}><p>{i + 1}</p></div>
                                <div className="text-center" style={{width: "130px"}}><p>{cData.hsCodeNm}</p></div>
                                <div className="text-center" style={{width: "220px"}}><p>{cData.hsCodeEnNm}</p></div>
                                <div className="font-b wd-80 text-center"><p>{cData.hsCode}</p></div>
                                <div className="font-b wd-120 text-center"><p>{cData.mcNm}</p></div>
                                <div className="text-center" style={{width: "110px"}}><p>{cData.regNm}</p></div>
                                <div className="text-center" style={{width: "100px"}}><p>{cData.regTime}</p></div>
                                <div className="text-center" style={{width: "110px"}}><p>{cData.modiNm}</p></div>
                                <div className="text-center" style={{width: "100px"}}><p>{cData.modiTime}</p></div>
                            </div>
                        ))}
                    </div>
                    {displayLimit >= 30 && data.length > displayLimit && (
                        <div className="text-center m-t-20">
                            <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                            </button>
                        </div>
                    )}
                </div>
            </div>


            {
                saveFailedShow ?
                    <MsgCheckModal
                        saveFailedShow={saveFailedShow}
                        closeSaveFailedShow={closeSaveFailedShow}
                    />
                    :
                    modifyFailedShow ?
                        <MsgCheckModal
                            modifyFailedShow={modifyFailedShow}
                            closeModifyFailedShow={closeModifyFailedShow}
                        />
                        :
                        deleteFailedShow ?
                            <MsgCheckModal
                                deleteFailedShow={deleteFailedShow}
                                closeDeleteFailedShow={closeDeleteFailedShow}
                            />
                            :
                            nonSelectedShow ?
                                <MsgCheckModal
                                    nonSelectedShow={nonSelectedShow}
                                    closeNonSelectedShow={closeNonSelectedShow}
                                />
                                :
                                nonDataShow ?
                                    <MsgCheckModal
                                        nonDataShow={nonDataShow}
                                        closeNonDataShow={closeNonDataShow}
                                    />
                                    :
                                    modifyPopupShow ?
                                        <AdminCtItemModify
                                            modifyPopupShow={modifyPopupShow}
                                            closeModifyPopupShow={closeModifyPopupShow}
                                            checkedCtList={checked}
                                            modifyCustomItem={modifyCustomItem}
                                        />
                                        :
                                        deleteShow ?
                                            <MsgSelectModal
                                                deleteShow={deleteShow}
                                                closeDeleteShow={closeDeleteShow}
                                                deleteMsg1={deleteMsg1}
                                                deleteMsg2={deleteMsg2}
                                                deleteCustomItem={deleteCustomItem}
                                            />
                                            :
                                            null
            }
        </div>
    );
}

export default AdminCustomsItemPg
